export default "__VITE_ASSET__cPKDky$9__"